import { Component, OnInit } from '@angular/core';
import { MenuStore } from '../service/menu.store';
import { OnyxEvent } from '../../event/models/event';
import { EventStore } from '../../event/service/event.store';
import { EventSearchParametersStore } from '../../event/service/event-search-parameters.store';

@Component({
  selector: 'pioneer-event-menu',
  templateUrl: './event-menu.component.html'
})
export class EventMenuComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public eventTitle = 'COMMON.NAV.EVENT_INFORMATION';
  public includeSubNav = true;

  constructor(
    private eventStore: EventStore,
    private menuStore: MenuStore,
    private eventSearchParameterStore: EventSearchParametersStore) {
  }

  ngOnInit() {
    this.menuStore.isReadOnly.subscribe(isReadOnly => {
      this.includeSubNav = isReadOnly;
      this.eventTitle = isReadOnly ? 'COMMON.NAV.EVENT_INFORMATION' : 'COMMON.NAV.EDIT_EVENT';
    });

    this.onyxEvent = new OnyxEvent();
    this.eventStore.selectedEvent.subscribe(value => {
      this.onyxEvent = new OnyxEvent(value);
    });
  }

  navigateToSearch(): void {
    this.eventSearchParameterStore.updateUrl();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/event-menu/event-menu.component.ts